import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Cookies from 'js-cookie' //cookies
Vue.prototype.$Cookies = Cookies; //全局使用cookie
import './icons' // 引入icon
/* elementui */
import enLang from 'element-ui/lib/locale/lang/zh-CN'
import Table from "@/components/Table/index";
Vue.component("Table", Table);
import oriTable from "@/components/Table/oriTable";
Vue.component("oriTable", oriTable);
import Pagination from "@/components/Pagination/index";
Vue.component("Pagination", Pagination);
import * as eg from "@/varfunction"
Vue.prototype.$eg = eg;
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import ExportUtil from '../src/views/js/ExportUtil'
Vue.prototype.ExportUtil = ExportUtil;
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/icon.css'
Vue.use(Element, {
  size: 'medium', // set element-ui default size
  locale: {
    el: {
      ...enLang.el, pagination: {
        pagesize: 'rows/page',
        total: `Totally {total} rows`,
        goto: 'goto',
        pageClassifier: 'page'
      }
    }
  }
})

Vue.config.productionTip = false

import { globalVariable } from '@/global/Variable'
Vue.prototype.$globalVariable = globalVariable; //全局变量

import * as methodCookies from "@/utils/methodCookies";
Vue.prototype.$methodCookies = methodCookies; //定义全局cookie方法



import 'amfe-flexible'//自适应
import '@/utils/rem.js'
import "@/log";//引入log监听文件
import vConsole from '@/utils/vconsole' //移动端显示console
import consoleFu from '@/utils/consoleLog' //移动端显示console方法
import '@/styles/globalCss.scss'//全局css样式
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

document.addEventListener('keydown', function (event) {//去除表单回车刷新页面
  // console.log(event.target)
  if (event.target && event.target.form === null) return; // 只对表单元素生效
  // debuger
  if (event.code !== "Enter") return; // 判断按下的键是否为 Enter 键
  if (event.target.type === "textarea" && event.target.form !== null) return // 对于表单textarea元素回车失效
  event.preventDefault(); // 取消默认行为（即不会刷新页面）
});

var lastClickTime = 0, count = 0
document.addEventListener('click', function (event) {//控制台显示
  // console.log(event.target.className)
  if (event.target.className.indexOf("vc-") != -1) {
    count = 0
    return
  }
  const nowTime = new Date().getTime();
  if (nowTime - lastClickTime < 1000) {
    count++;
  } else {
    count = 0;
  }
  lastClickTime = nowTime;
  if (count >= 10) {
    let vconDom = document.getElementById('__vconsole');
    consoleFu.toggleClass(vconDom, 'show')
    count = 0;

  }
});
